export default "__VITE_ASSET__Dumbu0fl__"